import { IMigrationImport } from './migrationimport.types';


var importData = {
    user: {},
    otherInfo: {},
    application: {
        projectSummary: {},
        budget: {}
    }
}

export class MigrationImport implements IMigrationImport {
    MigrationImportId: number;
    ProgramId: number;
    InitiativeCallId: number;
    ProgramOfficerId: number;
    GrantCode: string;
    GrantStatusId: number;
    ImportData: any;
    WorkflowStatusId: number;
    Users: any;
    Tags: any;
    Schema: any;
    GrantSchema: any;
    SelectedTopMenu: string;
    SelectedSubMenu: string;
    Indicators: any;
    Impact: any;
    Currency : string;
    Currencies : string;
    BudgetCategories : any;
    IsFixedIndirectCost: any;
    IndirectCost: any;
    constructor(data: IMigrationImport) {
        this.MigrationImportId = data.MigrationImportId
        this.GrantCode = data.GrantCode
        this.GrantStatusId = data.GrantStatusId
        this.InitiativeCallId = data.InitiativeCallId
        this.ProgramOfficerId = data.ProgramOfficerId
        this.ProgramId = data.ProgramId
        this.ImportData = data.ImportData || importData
        this.WorkflowStatusId = data.WorkflowStatusId
        this.Schema = data.Schema
        this.GrantSchema = data.GrantSchema
        this.SelectedTopMenu = data.SelectedTopMenu || ''
        this.SelectedSubMenu = data.SelectedSubMenu || ''
        this.Users = data.Users || []
        this.Tags = data.Tags || []
        this.Indicators=data.Indicators
        this.Impact=data.Impact
        this.Currency=data.Currency
        this.Currencies=data.Currencies
        this.BudgetCategories=data.BudgetCategories
        this.IsFixedIndirectCost = data.IsFixedIndirectCost
        this.IndirectCost = data.IndirectCost
    }
}
